import { Box } from "@mui/material";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import backgroundImage from "../assets/background.svg";
import Sidebar from "../components/Sidebar/Sidebar";
import styles from "./MainLayout.module.css";

const MainLayout = (showSideBar = true) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return (
        <Box
            className={styles.container}
            style={{ backgroundImage: `url(${backgroundImage})` }}
        >
            {showSideBar && (
                <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
            )}

            <Box
                component="main"
                className={styles.content}
                marginLeft={isSidebarOpen ? "200px" : "100px"}
                sx={{
                    "& > div": {
                        height: "100%",
                        width: "100%",
                    },
                }}
            >
                <Outlet />
            </Box>
        </Box>
    );
};

export default MainLayout;
